__turbopack_context__.v({
  "button": "EditButton-module-scss-module__p6GKtG__button",
});
